import Vue from 'vue'
import {REQUEST_API} from "./api"

export function getActivityInfo() {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.getActivityStatus}`).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}

export function userLogin(param) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.getUserInfo}`, param).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}

export function activityPrizeSet(param) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.activityGiftSet}`, param).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}

export function getUserPrizeHistory(param) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.getHistory}`, param).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}

export function lotteryPrize(param) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.openPrize}`, param).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}

export function getUserLotteryCount(param) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.checkUserCount}`, param).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}

export function checkUserStatus(param) {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.checkUserRule}`, param).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}

export function getPcImages() {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.getPCImages}`).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}

export function leaderBoardList() {
  return new Promise((resolve, reject) => {
    Vue.http.post(`${REQUEST_API.getLeaderBoard}`).then(res => {
      resolve(res.data)
    }, (error) => {
      reject(error)
    })
  })
}




// WEBPACK FOOTER //
// ./src/utils/request.js